import type { StackFrame } from 'stacktrace-js';
import type { ComponentInternalInstance, ComponentPublicInstance } from 'vue';

import type { VGL_ERROR_CODE } from '@/services/errorHandler/errorCodes';
import type { VglError } from '@/services/errorHandler/vglError';

export interface ErrorToHandle {
  error: VglError;
  stackTrace: StackFrame[];
  instance: ComponentPublicInstance | ComponentInternalInstance | null;
  info: string;
  timestamp: Date;
}

export type VGLErrorMessages = {
  [key in VGL_ERROR_CODE]: string;
};

export type VGLUserErrorMessages = {
  [key in VGL_ERROR_CODE]?: string;
};

export interface VGLErrorHandlerService {
  handle: (error: ErrorToHandle) => void;
}

export enum VGL_ERROR_HANDLER_SERVICE {
  CONSOLE = 'consoleErrorHandler',
  SENTRY = 'sentryErrorHandler',
}

export interface VglErrorOptions {
  userModalMessage?: string;
  userModalTitle?: string;
  additionalErrorMessage?: string;
  errorCallback?: () => void;
  skipServiceHandler?: VGL_ERROR_HANDLER_SERVICE[];
  cause?: unknown;
  additionalData?: unknown;
  isNonClosableUserModal?: boolean;
}
